import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { InfluencerService } from "../services/influencer.service";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import {
  Influencer,
  CreateInfluencerRequest,
  ICreateInfluencerRequest,
} from "@shared/lib/types/influencer";
import { BackednResponse } from "@shared/lib/types";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "@entities/brief/lib/constants";

export function useCreateInfluencer() {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: async (influencer: ICreateInfluencerRequest) => {
      return await InfluencerService.createInfluencer(influencer).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
